<template>
  <div class="__wrapper">
    <div class="__head"></div>
    <div class="__body">
      <div class="__container">
        <div class="__section-center">
          <div class="section-center__layout">
            <div class="layout__left">
              <div class="__card lesss">
                <div class="contact-card">
                  <div class="section">
                    <img :src="$fullUrl('images/profiles/'+user.profile)" />
                    <h2>{{user.names | validate }}</h2>
                    <span>{{user.job | validate }}</span>
                    <span>{{user.location | validate }}</span>
                  </div>
                  <div class="section">
                    <span>{{user.phone | validate }}</span>
                    <span>{{user.email | validate }}</span>
                  </div>
                  <div class="section">
                    <span>{{user.available | validate }}</span>
                    <span>{{user.available_from | validate }}</span>
                  </div>
                </div>
              </div>
              <div class="__card less">
                <div class="wrapper">
                  <router-link to="/profile/consultant">
                    <div class="item-row">
                      <img src="../assets/icons/profile.svg" />
                      <span>Profile</span>
                      <img class="fin" src="../assets/icons/editt.svg" />
                    </div>
                  </router-link>
                  <router-link to>
                    <div class="item-row">
                      <img src="../assets/icons/customer.svg" />
                      <span>Customers</span>
                      <span class="fin">10</span>
                    </div>
                  </router-link>
                  <router-link to>
                    <div class="item-row">
                      <img src="../assets/icons/lead.svg" />
                      <span>Leads</span>
                      <span class="fin">10</span>
                    </div>
                  </router-link>
                </div>
              </div>
              <div class="__card less">
                <div class="__body">
                  <h3>Trending</h3>
                  <div class="__item" v-for="(tag,i) in getMeProfile.tags">
                    <label @click="getFeedsbyTag(tag.name)">#{{tag.name | validate }}</label>
                    <label @click="getFeedsbyTag(tag.name)">{{tag.feed_count | validate }}</label>
                  </div>
                </div>
              </div>
              <div class="__suggestion-box">
                <div class="__body">
                  <div class="vertical">
                    <span>About Help Center</span>
                    <span>Privacy & Terms</span>
                    <span>Advertising</span>
                    <span>Business Services</span>
                    <img src="../assets/icons/log_dark.svg" />
                    <h1>Meritios</h1>
                    <label>Meritios © 2019</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="layout__right">
              <div class="__post-box" :class="{error : isEmpty}">
                <div class="input__post">
                  <img :src="$fullUrl('images/profiles/'+user.profile)" />
                  <textarea placeholder="What’s new, write something" v-model="postData.text"></textarea>
                </div>
                <div class="post" v-if="postData.imageUrl">
                  <img :src="postData.imageUrl" />
                  <button @click="removeImagee">Cancel</button>
                </div>
                <!--                                <div class="post" v-if="postData.videoFile">-->
                <!--                                    <img :src="postData.imageUrl">-->
                <!--                                    <button @click="removeImagee">Cancel</button>-->
                <!--                                </div>-->
                <div class="__actions">
                  <div class="icons">
                    <div class="__icon" @click.stop="pickImageFile(false)">
                      <img src="../assets/icons/image.svg" />
                    </div>
                    <div class="__icon" @click.stop="pickVideoFile(false)">
                      <img src="../assets/icons/capture.png" v-if="postData.thumbnail" />
                      <img src="../assets/icons/video.svg" v-else />
                    </div>
                    <!--                                        <div class="__icon">-->
                    <!--                                            <img src="../assets/icons/audio.svg">-->
                    <!--                                        </div>-->
                  </div>
                  <div class="btn-post" @click.stop="savePost">
                    <img src="../assets/icons/arrowup.svg" />
                  </div>
                </div>
                <input
                  type="file"
                  style="display: none"
                  ref="image"
                  accept="image/*"
                  @change="onImagePicked"
                />
                <input
                  type="file"
                  style="display: none"
                  ref="video"
                  accept="video/*"
                  @change="onVideoPicked"
                />
              </div>
              <div>
                <div class="__post-item" v-for="(post,i) in feeeds">
                  <div class="__header">
                    <img
                      v-if="post.user.profile_picture"
                      :src="$fullUrl('images/profiles/'+post.user.profile_picture)"
                    />
                    <img v-else src="../assets/avatar.png" alt />
                    <div class="__time">
                      <label class="__green">{{post.user.first_name | validate }} {{post.user.last_name | validate }}</label>
                      <span>{{ post.created_at | moment("add", "2 hours") | moment("from")  | validate }}</span>
                    </div>
                  </div>
                  <div class="__paragraph">
                    <p v-html="post.feed"></p>
                    <img v-if="post.image" :src="$fullUrl('images/feeds/'+post.image)" />
                    <video v-if="post.video" autoplay controls>
                      <source :src="$fullUrl('videos/feeds/'+post.video)" />Your browser is out of date.
                    </video>
                  </div>
                  <div class="__actions">
                    <div class="__likes">
                      <img src="../assets/icons/like.svg" @click="feedLike(post)" />
                      <span>{{ post.likes.length  | validate }}</span>
                    </div>
                    <div class="__likes" @click="showComment(post)">
                      <img src="../assets/icons/comment.svg" />
                      <span>{{Object.keys(post.comments).length | validate }}</span>
                    </div>
                    <!--<div class="__likes">-->
                    <!--<img src="../assets/icons/share.svg">-->
                    <!--<span>34</span>-->
                    <!--</div>-->
                  </div>
                  <div
                    class="__comments"
                    v-show="post.comments  && post.showComment"
                    id="comment-parent"
                  >
                    <div class="__coment" v-for="(c, i) in post.comments">
                      <img
                        v-if="c.user.profile_picture"
                        :src="$fullUrl('images/profiles/'+c.user.profile_picture)"
                      />
                      <img v-else src="../assets/avatar.png" alt />
                      <div class="__text">
                        <h6 class="__green">{{c.user.first_name | validate }} {{c.user.last_name | validate }}</h6>
                        <p>{{c.comment | validate }}</p>
                        <div class="__actions">
                          <span class="__green" @click="commentLike(c)">
                            <span
                              class="__green"
                              v-show="c.likes && c.likes.length > 0"
                            >{{c.likes.length | validate }}</span>Like
                          </span>
                          <!--<span class="__green">.</span>-->
                          <!--<span class="__green">Reply</span>-->
                          <span class="__green">.</span>
                          <span>{{ c.created_at | moment("add", "2 hours") | moment("from")  | validate }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="__comments-wrapper">
                    <div class="__comment__post-box">
                      <img
                        v-if="getMeProfile.user.profile_picture"
                        :src="$fullUrl('images/profiles/'+getMeProfile.user.profile_picture)"
                      />
                      <img v-else src="../assets/avatar.png" alt />
                      <textarea
                        placeholder="Comment something"
                        v-model="post.text"
                        @keyup.enter="saveComment(post.text,i,post)"
                      ></textarea>
                      <input
                        type="file"
                        style="display: none"
                        ref="image2"
                        accept="image/*"
                        @change="onImagePicked2"
                      />
                      <input
                        type="file"
                        style="display: none"
                        ref="video2"
                        accept="video/*"
                        @change="onVideoPicked2"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="__section-right"></div>
      </div>
      <div class="floater">
        <chat></chat>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchPage",
};
</script>

<style scoped>
</style>